import request from "@/utils/request";
//获取所有招募项目名称列表
export function getAllProjects(data){
    return request({
        url:'/getAllProjects',
        data:data,
        method:'get'
    })
}
//青年科学家申报
export function addSciApply(data){
    return request({
        url:'/web/addSciApply',
        data:data,
        method:'post'
    })
}
//查询当前用户的青年科学家招募申请状态
export function getSciApplyDetail(data){
    return request({
        url:'/web/getSciApplyDetail',
        data:data,
        method:'get'
    })
}
